import { atom } from "jotai";

/**
 * File des toasts de paiement in-app (feed « ka-ching » en bas du cockpit).
 *
 * Alimentée par `usePaymentSound` (qui détecte déjà les nouveaux events du feed
 * temps réel Convex `recentForMe`) et consommée par `<PaymentToasts>`. C'est le
 * pendant VISUEL du son : quand le cockpit est ouvert (desktop surtout), chaque
 * paiement affiche une petite carte qui s'auto-efface, en plus du son.
 */
export interface PaymentToast {
  /** id de l'event Convex (unique → clé React + dédup). */
  id: string;
  tier: "small" | "medium" | "large";
  amountCents: number;
  currency: string;
  creatorName: string | null;
  /** Quoi a été vendu (nom du média/offre), si connu. */
  itemSold: string | null;
  /** Vente faite par l'IA Cyrano (true) ou un humain (false/null). */
  soldByAi: boolean | null;
  /** Nom du membre vendeur quand humain. */
  soldByName: string | null;
  /** 🎯 La conversation où ça s'est vendu — le toast l'ouvre au clic. `null`
   *  quand l'événement ne la porte pas (ancien backend, ou commande sans
   *  conversation) : le toast se ferme au clic, comme avant. */
  conversationId: string | null;
  /** Le nom du fan, pour titrer l'onglet qu'on ouvre. */
  fanName: string | null;
  /** 🔊 C'est MOI qui ai vendu : la vente se fête au milieu de l'écran. */
  estAMoi: boolean;
  /** 🔊 Cette fenêtre a gagné le son (une seule fenêtre sonne par personne). */
  sonIci: boolean;
  /** 🎳 Mes ventes enchaînées (≤ 30 min d'écart), celle-ci comprise. */
  combo: number;
  /** Ma n-ième vente du jour — `null` quand le feed ne permet pas de le savoir. */
  venteDuJour: number | null;
  totalDuJourCents: number | null;
}

/** Toasts actuellement affichés (plus récent en tête). Cappé côté producteur. */
export const paymentToastsAtom = atom<PaymentToast[]>([]);
